var MotoSearchJs = (function ($) {

    var removeSelectBoxesContent = function( selectBoxList ){
        for(var selectBoxId in selectBoxList){
            $(selectBoxList[selectBoxId]).find('option:gt(0)').remove();
            $(selectBoxList[selectBoxId]).prop('disabled', true);
            $(selectBoxList[selectBoxId]+' option:first-child').prop("selected", true);
        }
    };

    var displayErrorDiv = function(){
        $(".motoselector-error-div").show();
    };

    var addHandlers = function() {
       addManufacturerSelectorHandler();
       addCapacitySelectorHandler();
       addModelSelectorHandler();
    };

    var initDropdowns = function() {
        var manufacturerId = $("#motoselector-default-manufacturer option:selected").val();
        if( manufacturerId !== null && manufacturerId !== "") {
            $('#motoselector-default-manufacturer').trigger("change");
        }
    };

    var addManufacturerSelectorHandler = function(){
        $('#motoselector-default-manufacturer').off().on('change',function() {
                var manufacturerId = $("#motoselector-default-manufacturer").val();
                removeSelectBoxesContent(['#motoselector-default-capacity','#motoselector-default-model','#motoselector-default-type']);
                $("#motoselector-default-submit").prop('disabled', true);
                $.ajax({
                    type : 'GET',
                    url : "/ws/moto/capacities/search?manufacturer=" + manufacturerId,
                    success : function(data) {
                        if (data){
                            var triggerChange = false;
                            var capacitySelector = $("#motoselector-default-capacity");
                            capacitySelector.prop('disabled',false).trigger("focus");
                            for ( var i in data.list) {
                                if (data.selectedKey != data.list[i]) {
                                    capacitySelector.append(
                                        "<option value='" + data.list[i] + "'>" + data.list[i]+"</option>");
                                } else {
                                    capacitySelector.append(
                                        "<option selected value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                                    triggerChange = true;
                                }
                            }
                            $(".motoselector-default-capacity").show();
                            if (data.list.length === 1) {
                                // select first element
                                capacitySelector.val(data.list[0]);
                                triggerChange = true;
                            }

                            if (triggerChange) {
                                capacitySelector.trigger("change");
                            }
                        }
                    },
                    error : function(xhr, ajaxOptions, thrownError) {
                       displayErrorDiv();
                    }
                });
            }
        );
    }

    var addCapacitySelectorHandler= function() {
        $('#motoselector-default-capacity').off().on('change',function() {
            var manufacturerId = $("#motoselector-default-manufacturer").val();
            var capacityID = $("#motoselector-default-capacity option:selected").val();
            removeSelectBoxesContent(['#motoselector-default-model','#motoselector-default-type']);
            $("#motoselector-default-submit").prop('disabled', true);
            $.ajax({
                type : 'GET',
                url : "/ws/moto/models/search?manufacturer=" + manufacturerId+"&capacity="+ capacityID,
                success : function(data) {
                    if (data){
                        var triggerChange = false;
                        var modelSelector = $("#motoselector-default-model");
                        modelSelector.prop('disabled', false).trigger("focus");
                        for ( var i in data.list) {
                            if (data.selectedKey != data.list[i].modelName) {
                                modelSelector.append(
                                    "<option value='" + data.list[i].modelName + "'>" + data.list[i].modelName + "</option>");
                            } else {
                                modelSelector.append(
                                    "<option selected value='" + data.list[i].modelName + "'>" + data.list[i].modelName + "</option>");
                                triggerChange = true;
                            }
                        }
                        $(".motoselector-default-model").show();
                        if (data.list.length === 1) {
                            // select first element
                            modelSelector.val(data.list[0].modelName);
                            triggerChange = true;
                        }

                        if (triggerChange) {
                            modelSelector.trigger("change");
                        }
                    }
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    $(".motoselector-error-div").show();
                }
            });
          }
        );
     };

    var addModelSelectorHandler= function() {
        $('#motoselector-default-model').off().on('change',function() {
             var manufacturerId = $("#motoselector-default-manufacturer").val();
             var capacityID = $("#motoselector-default-capacity option:selected").val();
             var modelID = $("#motoselector-default-model option:selected").val();
             removeSelectBoxesContent(['#motoselector-default-type']);
             $("#motoselector-default-submit").prop('disabled', true);
             $.ajax({
                 type : 'GET',
                 url : "/ws/moto/types/search?manufacturer=" + manufacturerId+"&capacity="+ capacityID + "&model="+ modelID,
                 success : function(data) {
                     if (data){
                         var typeSelector = $("#motoselector-default-type");
                         for ( var i in data.list) {
                             if (data.selectedKey != data.list[i]) {
                                 typeSelector.append(
                                     "<option value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                             } else {
                                 typeSelector.append(
                                     "<option selected value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                             }
                         }
                         // Check if type list is empty
                         var listVal = typeSelector[0].length;
                         if(listVal==1){
                             $("#motoselector-default-submit").prop('disabled', false);
                         }
                         else{
                             $(".motoselector-default-type").show();
                             typeSelector.prop('disabled', false).trigger("focus");
                             addTypeSelectorHandler();
                             if (data.list.length === 1) {
                                 // select first element
                                 typeSelector.val(data.list[0]);
                             }
                             typeSelector.trigger("change");
                         }
                     }
                    },
                 error : function(xhr, ajaxOptions, thrownError) {
                     $(".motoselector-error-div").show();
                 }
             });
           }
         );
          };

    var addTypeSelectorHandler = function() {
        $('#motoselector-default-type').off().on('change',function() {
                if (this.value != '') {
                    $("#motoselector-default-submit").prop('disabled', false);
                } else{
                    $("#motoselector-default-submit").prop('disabled', true);
                }
            }
        );
    };
    return {
        addHandlers: addHandlers,
        initDropdowns: initDropdowns
    }
}) (jQuery);

$(document).ready(function() {
    var manufacturerSelector = $('#motoselector-default-manufacturer');
    if ( manufacturerSelector.length ) {
        MotoSearchJs.addHandlers();
        MotoSearchJs.initDropdowns();
    }
});